import React, { useContext, useEffect, useState } from 'react';
import { RFeature, RLayerTile, RLayerVector, RMap, RStyle } from 'rlayers';
import { fromLonLat } from 'ol/proj';
import { boundingExtent, getCenter } from 'ol/extent';
import { Point } from 'ol/geom';
import 'ol/ol.css';
import './Map.css';

import AppContext from '../data/AppContext';
import { useNavigate } from 'react-router-dom';

import claimedIcon from '../assets/vote-blue.png';
import { getMountain } from '../utils/moutainDetails';

const Map = () => {
  const extent = boundingExtent([
    fromLonLat([5.284711, 44.865495]),
    fromLonLat([11.184369, 48.467357]),
  ]);
  const center = getCenter(extent);

  const { activeMountain, claimedMountainIds, setActiveMountain } =
    useContext(AppContext);
  const navigate = useNavigate();
  const [claimedMountains, setClaimedMountains] = useState([]);

  const [selectedMountain, setSelectedMountain] = useState(undefined);

  //styles
  const claimedStyle = RStyle.useRStyle();
  const unclaimedStyle = RStyle.useRStyle();
  const activeStyle = RStyle.useRStyle();

  useEffect(() => {
    if (activeMountain) {
      setSelectedMountain(getMountain(activeMountain));
    } else {
      setSelectedMountain(undefined);
    }
  }, [activeMountain]);

  useEffect(() => {
    const cm = [];
    claimedMountainIds.forEach((id) => {
      cm.push(getMountain(id));
    });
    setClaimedMountains(cm);
  }, [claimedMountainIds]);

  const handleClick = (id) => {
    navigate(`/glaciers/${id}`);
    return false;
  };

  return (
    <>
      <RStyle.RStyle ref={claimedStyle}>
        <RStyle.RIcon src={claimedIcon} scale={0.18} />
      </RStyle.RStyle>

      <RStyle.RStyle ref={unclaimedStyle}>
        <RStyle.RCircle radius={10}>
          <RStyle.RFill color="#FAEA5D" />
          <RStyle.RStroke color={'black'} width={1} />
        </RStyle.RCircle>
      </RStyle.RStyle>

      <RStyle.RStyle ref={activeStyle}>
        <RStyle.RCircle radius={15}>
          <RStyle.RFill color="red" />
          <RStyle.RStroke color={'black'} width={2} />
        </RStyle.RCircle>
      </RStyle.RStyle>

      <RMap
        width={'100%'}
        height={'100%'}
        initial={{ center: center, zoom: 7 }}
        extent={extent}
        maxZoom={14}
        noDefaultControls={true}
        className={'pow-map'}
        enableRotation={false}
        onMoveEnd={() =>
          (document.querySelector('.pow-map').style.cursor = 'grab')
        }
        onPointerDrag={() =>
          (document.querySelector('.pow-map').style.cursor = 'grabbing')
        }
        onClick={() => {
          setActiveMountain();
          navigate(`/`);
        }}
      >
        <RLayerTile
          url="https://wmts.geo.admin.ch/1.0.0/ch.swisstopo.pixelkarte-farbe/default/current/3857/{z}/{x}/{y}.jpeg"
          attributions="© Swisstopo"
          zIndex={1}
        />

        <RLayerVector zIndex={15}>
          {claimedMountains
            .filter((mountain) => mountain.id !== activeMountain)
            .map((mountain, i) => (
              <MapFeature
                mountain={mountain}
                key={i}
                style={claimedStyle}
                handleClick={(id) => handleClick(id)}
              />
            ))}
        </RLayerVector>

        {selectedMountain && (
          <RLayerVector zIndex={20}>
            <MapFeature mountain={selectedMountain} style={activeStyle} />
          </RLayerVector>
        )}
      </RMap>
    </>
  );
};

const MapFeature = ({
  mountain,
  style,
  handleClick = () => {
    return false;
  },
}) => {
  return (
    <RFeature
      geometry={new Point(fromLonLat([mountain.lon, mountain.lat]))}
      onPointerEnter={() =>
        (document.querySelector('.pow-map').style.cursor = 'pointer')
      }
      onPointerLeave={() =>
        (document.querySelector('.pow-map').style.cursor = 'grab')
      }
      onClick={() => handleClick(mountain.id)}
      style={style}
    />
  );
};

export default Map;
